///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>


module Meevo.Components.Controls.SmartMover {


    import IReportDistributor = Meevo.Plugins.Reports.IReportDistributor;
    import IReportInventoryReturns = Meevo.Plugins.Reports.IReportInventoryReturns;

    export class InventoryReturnsToDistributorStrategy implements ICollectionPopulate {
        constructor(public parent: ICollectionBase<IReportDistributor>, public child: ICollectionBase<IReportInventoryReturns>) {
        }

        populate(): void {
            this.parent.models.forEach((category: ISmartMoverCategoryModel<IReportDistributor>) => {
                category.resetModels([]);
            });

            for (const category of this.parent.models) {
                (<ISmartMoverCategoryModel<IReportDistributor>>category).resetModels(
                    this.child.models.filter(model => model.get('distributor_TId') === category.id)
                );
            }
        }
    }
}